import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";

export default function ImpressumPage() {
  const navigate = useNavigate();

  return (
    <div className="px-5 pt-4 pb-8" data-testid="impressum-page">
      <button
        onClick={() => navigate(-1)}
        data-testid="impressum-back"
        className="text-slate-600 flex items-center gap-1 text-sm mb-3"
      >
        <ArrowLeft className="w-4 h-4" /> Zurück
      </button>

      <h1 className="text-2xl font-bold text-slate-900">Impressum</h1>
      <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold mt-1">
        Angaben gemäß § 5 DDG
      </p>

      <Section title="cc-onlinekurse">
        <p>Inhaber: Claudiu Ciobotaru</p>
        <p>Gestütring 3</p>
        <p>85435 Erding</p>
        <p>Deutschland</p>
      </Section>

      <Section title="Kontakt">
        <p className="flex items-center gap-2">
          <Mail className="w-4 h-4 text-blue-600 shrink-0" />
          <a
            href="mailto:info@cc-onlinekurse.de"
            className="text-blue-700 underline underline-offset-2"
            data-testid="impressum-email"
          >
            info@cc-onlinekurse.de
          </a>
        </p>
      </Section>

      <Section title="Verantwortlich für den Inhalt">
        <p>Claudiu Ciobotaru</p>
        <p>Gestütring 3</p>
        <p>85435 Erding</p>
        <p>Deutschland</p>
      </Section>

      <Section title="Verbraucherstreitbeilegung">
        <p>
          Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </Section>

      <Section title="Haftung für Inhalte">
        <p>
          Als Diensteanbieter sind wir für eigene Inhalte in dieser App nach den allgemeinen
          Gesetzen verantwortlich. Eine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität
          der bereitgestellten Inhalte kann jedoch nicht übernommen werden.
        </p>
      </Section>

      <Section title="Hinweis zu BriefAssist">
        <p>
          BriefAssist dient der automatisierten Analyse, Zusammenfassung und verständlichen
          Erklärung von Dokumenten. Die bereitgestellten Informationen stellen keine Rechts-,
          Steuer- oder sonstige professionelle Beratung dar. Bei rechtlich oder finanziell
          relevanten Angelegenheiten sollte im Zweifel fachkundige Beratung eingeholt werden.
        </p>
      </Section>

      <p className="text-xs text-slate-500 mt-6" data-testid="impressum-stand">
        Stand: August 2026
      </p>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mt-5 rounded-2xl bg-white border border-slate-200 p-4">
      <h2 className="text-base font-semibold text-slate-900 mb-2">{title}</h2>
      <div className="text-[14px] text-slate-700 leading-relaxed space-y-1">
        {children}
      </div>
    </section>
  );
}
